import React from 'react';
import 'semantic-ui-css/semantic.min.css'
import './App.css';
import DosingChart from './components/DosingChart';

function App() {
  return (
    <div className="App">
      <DosingChart />
    </div>
  );
}

export default App;
